var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_vm._v("\n  "+_vm._s(_vm.result.length)+"\n  "),_c('b-table',{attrs:{"items":_vm.result}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }